import { render, staticRenderFns } from "./SuccessbuyMoney.vue?vue&type=template&id=5e092b08&scoped=true&"
import script from "./SuccessbuyMoney.vue?vue&type=script&lang=ts&"
export * from "./SuccessbuyMoney.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessbuyMoney.vue?vue&type=style&index=0&id=5e092b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e092b08",
  null
  
)

export default component.exports